import { render, staticRenderFns } from "./DismountAppliance.vue?vue&type=template&id=5d229a11"
import script from "./DismountAppliance.vue?vue&type=script&lang=js"
export * from "./DismountAppliance.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports